




































































































import SellerMessage from '~/components/car/classifieds/view/partials/seller/dealer/SellerMessage.vue'
import SellerUserSince from '~/components/car/classifieds/view/partials/seller/dealer/SellerUserSince.vue'
import SellerWorkingHours from '~/components/car/classifieds/view/partials/seller/dealer/SellerWorkingHours.vue'
import SellerBasicInfo from '~/components/car/classifieds/view/partials/seller/dealer/SellerBasicInfo'
import SellerTelephones from '~/components/car/classifieds/view/partials/seller/dealer/SellerTelephones'
import CExpandableContent from '~/components/shared/configurable/expand/CExpandableContent.vue'
import {
  computed,
  defineComponent,
  defineVue3AsyncComponent,
  ref
} from '~/utils/nuxt3-migration'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_VIEW_NS,
  ClassifiedViewState
} from '~/store/modules/shared/classifieds/view/state'
import CGoogleMapEmbed from '~/components/shared/configurable/map/CGoogleMapEmbed.vue'
import {
  sellerIsBlacklistedAsSuspiciousOrFraudster,
  sellerIsOfTypeDealer
} from '~/utils/user'
import { useUserAgent } from '~/compositions/user-agent'

export default defineComponent({
  components: {
    SellerMessage,
    OtherShops: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/view/partials/seller/dealer/OtherShops.vue'
      )
    ),
    SellerWorkingHours,
    SellerUserSince,
    SellerBasicInfo,
    SellerTelephones,
    SellerMiscInfo: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/view/partials/seller/dealer/SellerMiscInfo.vue'
      )
    ),
    SellerSocialMediaAndRating: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/view/partials/seller/dealer/SellerSocialMediaAndRating.vue'
      )
    ),
    CGoogleMapEmbed,
    CExpandableContent
  },
  props: {
    seller: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const {
      state: classifiedViewState,
      getters: classifiedViewGetters
    } = useNamespacedStore<ClassifiedViewState>(CLASSIFIED_VIEW_NS)
    const { isMobile } = useUserAgent()

    const expandableContentRef = ref(null)
    const isExpanded = ref(null)

    const isPlotClassified = computed(() =>
      classifiedViewGetters('isPlotClassified')
    )

    const marker = computed(() => {
      const { geolocation } = props.seller
      if (geolocation) {
        return {
          lat: geolocation[0],
          lon: geolocation[1]
        }
      }
      return null
    })

    const sellerIsDealerOrAgent = computed(() =>
      sellerIsOfTypeDealer(props.seller)
    )

    const sellerLink = computed(() => {
      if (sellerIsBlacklistedAsSuspiciousOrFraudster(props.seller)) {
        return undefined
      }

      const [lat, lon] = props.seller.geolocation
      return `https://www.google.com/maps?daddr=${lat},${lon}`
    })

    const marketplace = computed(() => classifiedViewState.marketplace)

    const isExpandableContentButtonVisible = computed(() => {
      const hasWorkingHours = Boolean(props.seller.working_hours)
      const hasMultipleOutlets = props.seller.outlets > 1
      const hasMessage = Boolean(props.seller.message)

      const hasMobileDealerInfo =
        isMobile.value &&
        marker.value &&
        sellerLink.value &&
        sellerIsDealerOrAgent.value

      return (
        hasWorkingHours ||
        hasMultipleOutlets ||
        hasMessage ||
        hasMobileDealerInfo
      )
    })

    const hasSocialOrRating = computed(() => {
      const { social_media: socialMedia, google_rating: googleRating } =
        props.seller ?? {}

      return (
        (socialMedia && Object.values(socialMedia).some(Boolean)) ||
        Boolean(googleRating)
      )
    })

    function toggleExpand() {
      expandableContentRef.value!.toggleExpand()
    }

    return {
      hasSocialOrRating,
      isPlotClassified,
      marketplace,
      marker,
      sellerLink,
      sellerIsDealerOrAgent,
      expandableContentRef,
      toggleExpand,
      isExpanded,
      isExpandableContentButtonVisible
    }
  }
})
